import { plainToClass } from 'class-transformer';
import { ClassType } from 'class-transformer/ClassTransformer';

export const ENTITY_NOT_FOUND_ERROR_KEY = 'entity_not_found';
export const ENTITY_ALREADY_EXISTS_ERROR_KEY = 'entity_already_exists';
export const ILLEGAL_ARGUMENT_ERROR_KEY = 'illegal_argument';
export const INSUFFICIENT_PERMISSIONS_ERROR_KEY = 'insufficient_permissions';
export const METHOD_NOT_ALLOWED_ERROR_KEY = 'method_not_allowed';

export function prepareCarrierParam(carrier: number | null): Record<string, any> {
  if (!carrier)
    return {};
  return { carrierId: carrier };
}

export function transformDataToClass<T>(data: any, type: ClassType<T>): void {
  data.forEach((element: Record<string, any>, index: number, theArray: T[]) => theArray[index] = plainToClass<T, Record<string, any>>(type, element));
}

export function hasError(error: any, errorKey: string): boolean {
  return error.status < 0 && (errorKey in error.errors || Object.values(error.errors).includes(errorKey));
}
